import { createTheme } from "@mui/material";

// import "../assets/fonts/AktivGroteskStdReg.ttf";

export default createTheme({
  typography: {
    fontFamily: "Love, Courier, Aktiv, Canopee",
    h1: {
      fontSize: "192px",
      fontFamily: "Canopee",
    },
    h2: {
      fontSize: "100px",
      fontFamily: "Canopee",
    },
    h5: { fontSize: "36px", letterSpacing: "1px" },
    body1: {
      fontFamily: "Aktiv",
      fontSize: "20px",
    },
    body2: {
      fontFamily: "Aktiv",
      fontSize: "14px",
    },
  },
  palette: {
    primary: {
      main: "#F98337",
      contrastText: "#343434",
    },
    secondary: {
      main: "#647CD1",
    },
    background: {
      default: "#E9E9E9",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
      @font-face {
        font-family: 'Love';
        font-style: normal;
        src: url('./fonts/Love.woff') format('woff');
      }
      @font-face {
        font-family: 'Canopee';
        font-style: normal;
        src: url('./fonts/Canopee.woff') format('woff');
      }

      @font-face {
        font-family: 'Aktiv';
        font-style: normal;
        src: url('./fonts/AktivGroteskStdReg.woff') format('woff');
      }
    `,
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
          color: "inherit",
          fontSize: 10,
          transition: "text-decoration 0.3s ease",
          "&:hover": {
            textDecoration: "line-through",
          },
        },
      },
    },
  },
});
